import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../context/LanguageContext";
import { t } from "../lib/i18n";
import { api, setAuthToken } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";

const AdminLoginPage = () => {
  const { tr } = useLang();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/admin/login", { email: email.trim().toLowerCase(), password });
      setAuthToken(res.data.token);
      localStorage.setItem("ap_admin_user", JSON.stringify({
        email: res.data.email, role: res.data.role, name: res.data.name,
        branch_id: res.data.branch_id, user_id: res.data.user_id,
      }));
      toast.success(tr({ en: "Signed in", hi: "साइन इन" }));
      if (res.data.role === "central_operator") navigate("/central");
      else if (res.data.role === "branch_operator") navigate("/branch");
      else navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || tr({ en: "Login failed", hi: "लॉगिन असफल" }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="max-w-md mx-auto px-4 lg:px-8 py-16">
      <div className="rounded-xl bg-white border border-slate-200 p-8">
        <div className="w-12 h-12 rounded-md bg-teal-50 text-teal-700 flex items-center justify-center mb-5">
          <Lock className="w-6 h-6" />
        </div>
        <h1 className="text-2xl font-heading font-semibold text-slate-900">{tr(t.admin.login)}</h1>
        <p className="mt-1 text-sm text-slate-600">{tr({ en: "Restricted area — staff only.", hi: "प्रतिबंधित क्षेत्र — केवल कर्मियों हेतु।" })}</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label className="text-sm">{tr(t.admin.email)}</Label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="admin-email-input" />
          </div>
          <div>
            <Label className="text-sm">{tr(t.admin.password)}</Label>
            <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" data-testid="admin-password-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full h-11 bg-teal-700 hover:bg-teal-800 text-white" data-testid="admin-signin-btn">
            {loading ? tr(t.common.submitting) : tr(t.admin.signin)}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default AdminLoginPage;
